import './footer.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';

const FooterComponent = () => {
  const phrases = useSelector((state: RootState) => state.phrases.value);
  
  return <>
    <footer>
      <section>
        <h2>{
          phrases[4] // Contacts
        }</h2>
        <p>SharpIT Ltd.</p>
        <p>{
          phrases[5] // Work hours
        }</p>
        <address>
          {phrases[6]} <br/>
          {phrases[7]}: <a href="tel:+359883359122">+359 88 33 59 122</a> <br/>
          {phrases[8]}: <a href="mailto:info@sharp-it.bg">info@sharp-it.bg</a> <br/>
        </address>
      </section>
      <section>
        <iframe src="https://maps.google.bg/maps?q=43.84842426372722,25.955422626982863&z=16&output=embed" height="250" width="500"></iframe>
      </section>
    </footer>
  </>
}

export default FooterComponent
